import { API_RESOURCE } from '@/constants/api.constant'
import useAction from '@/hooks/useAction'
import { useCrud } from '@/hooks/useCrud'
import { createOptions } from '@/utils/arrayHelper'
import { keepPreviousData, useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import VendorService from './vendor.service'

const useVendor = () => {
  const service = new VendorService()
  const baseCrud = useCrud(API_RESOURCE.VENDOR, service)

  const queryClient = useQueryClient()

  const useUploadVendors = () => {
    return useMutation({
      mutationFn: service.uploadVendor,
      onSuccess: (res) => {
        queryClient.invalidateQueries(baseCrud.queryKey.lists())
      },
    })
  }

  const useVendorOptions = ({ labelKey = 'name', valueKey = 'name', status = 'active' }) => {
    return useQuery({
      queryKey: [...baseCrud.queryKey.list({ page: 1, pageSize: 0, filters: { status: status } })],
      queryFn: () => service.fetchAll({ page: 1, pageSize: 0, filters: { status: status } }),
      placeholderData: [],
      select: (data) => createOptions(data?.data, labelKey, valueKey),
    })
  }

  const useRequestCreateTempVendor = useAction({
    mutationFn: service.requestCreateTempVendor,
    queryKey: baseCrud.queryKey,
    message: 'Successfully Request Create Temp Vendor',
  })

  return {
    //Base CRUD
    useFetchAllVendors: baseCrud.useFetchAll,
    useFetchVendor: baseCrud.useFetchOne,
    useCreateVendor: baseCrud.useCreate,
    useUpdateVendor: baseCrud.useUpdate,
    useRemoveVendor: baseCrud.useRemove,

    //Extra
    useUploadVendors,
    useVendorOptions,
    useRequestCreateTempVendor,
  }
}

export default useVendor
